import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_137: DocMigration = {
  maxSchemaVersion: "0.0.137",
  description: "Remap custom garage doors to new garage operation types",
  apply(json: any) {
    const { settings } = json;

    const settingsArray: any[] = Object.values(settings);

    // collect all exterior props here
    const exteriorProps = {};
    for (const settings of settingsArray) {
      if (settings.type === "EXTERIOR_PROP_SETTINGS") {
        Object.assign(exteriorProps, settings.propTypes);
      }
    }

    // find all of the door catalogs and update the operation types fields
    for (const settings of settingsArray) {
      if (settings.type === "DOOR_CATALOG_SETTINGS") {
        for (const doorTypeId of Object.keys(settings.doorTypes) as any[]) {
          const doorType = settings.doorTypes[doorTypeId];
          doorType.id = doorTypeId;

          if (doorType.operationType === "GARAGE") {
            const { propId } = doorType;
            const prop = exteriorProps[propId];

            // tags the door as a legacy garage door type
            // to prevent regressions in electrical system generation
            doorType.isLegacyGarageDoorType = true;

            if (!prop) {
              doorType.operationType = "GARAGE_SINGLE";
              continue;
            }

            const { propId: propCatalogId } = prop;

            if (propCatalogId.startsWith("DoorGar_D12x7")) {
              doorType.operationType = "GARAGE_SINGLE";
            } else if (propCatalogId.startsWith("DoorGar_D16x7")) {
              doorType.operationType = "GARAGE_DOUBLE";
            } else if (propCatalogId.startsWith("DoorGar_D18x7")) {
              doorType.operationType = "GARAGE_DOUBLE";
            } else if (propCatalogId.startsWith("DoorGar_D20X8")) {
              doorType.operationType = "GARAGE_DOUBLE";
            } else if (propCatalogId.startsWith("DoorGar_D10X8")) {
              doorType.operationType = "GARAGE_SINGLE";
            } else if (propCatalogId.startsWith("DoorGar_D8x7")) {
              doorType.operationType = "GARAGE_SINGLE";
            } else if (propCatalogId.startsWith("DoorGar_D9x7")) {
              doorType.operationType = "GARAGE_SINGLE";
            } else {
              doorType.operationType = "GARAGE_SINGLE";
            }
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_137;
